<template>
  <div :id="page_slug">
    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'TemplateList' }">Templates</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-row :gutter="30">
      <el-col :span="8">
        <el-card :body-style="{ padding: '20px' }">
          <img :src="template.thumbnail_url" class="img-responsive" />      
        </el-card>

        <el-card :body-style="{ padding: '20px' }" class="button_card" v-loading="loading.image_optimisation">
          <el-button 
            :disabled="template.optimised_thumbnail_url != ''"
            type="primary" 
            @click="optimiseImage()">
            Optimise Image
          </el-button>      
        </el-card>
      </el-col>

      <el-col :span="16">
        <el-tabs @tab-click="handleClick" type="card" v-model="active_tab">
          <el-tab-pane label="Details" name="details">
            <el-form 
              ref="template" 
              :model="template"
              :rules="rules.template"
              :label-position="label_position">

              <el-form-item label="Name" prop="name">
                <el-input disabled v-model="template.name"></el-input>
              </el-form-item>

              <el-form-item label="Display Name" prop="display_name">
                <el-input v-model="template.display_name"></el-input>
              </el-form-item>

              <el-form-item label="Description" prop="description">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="Please Input"
                  v-model="template.description">
                </el-input>
              </el-form-item>

              <el-form-item label="Size" prop="size">
                <el-input disabled v-model="template.size"></el-input>
              </el-form-item>

              <el-form-item label="Product:" prop="product_id">
                <el-select 
                  v-model="template.product_id"
                  value-key="id"
                  filterable
                  :clearable="true"
                  placeholder="Select product">
                  <el-option
                    v-for="item in products"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>  

              <el-form-item label="Editable Products" prop="editable_products">
                <el-input-number :min="0" v-model="template.editable_products"></el-input-number>
              </el-form-item>

              <el-form-item label="Corporation:" prop="company_id">
                <el-select 
                  v-model="template.company_id" 
                  placeholder="Select Here">
                  <el-option
                  v-for="item in corporations"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>  

              <el-form-item label="Private" prop="is_private">
                <el-switch
                    v-model="template.is_private"
                    :active-value="1"
                    :inactive-value="0">
                </el-switch>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="updateTemplate('template')">Update</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="Assigned Products" name="assigned-products">
            <el-card 
              hover="never"
              :body-style="{ padding: '0px' }">
                <div slot="header" class="clearfix">
                  <el-row>
                    <el-col :span="16">
                      <el-input
                      :clearable="true"
                      placeholder="Filter Products"
                      prefix-icon="el-icon-search"
                      v-model="filter_products"></el-input>
                    </el-col>
                    <el-col :span="6" :offset="2" class="text-right">
                      <el-button @click="assignTemplateToProducts()">Assign Products</el-button>
                    </el-col>
                  </el-row>
                </div>
                <div class="scroll-pane">
                  <el-checkbox-group v-model="selected_products">
                    <el-checkbox v-for="item in filteredProducts" :label="item.id" :key="item.id" class="checkbox-list">{{item.name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-card>
            </el-tab-pane>

            <el-tab-pane label="Assigned Categories" name="assigned-categories">
              <el-card 
                hover="never"
                :body-style="{ padding: '0px' }">
                <div slot="header" class="clearfix">
                  <el-row>
                    <el-col :span="16">
                      <el-input
                      :clearable="true"
                      placeholder="Filter Categories"
                      prefix-icon="el-icon-search"
                      v-model="filter_categories"></el-input>
                    </el-col>
                    <el-col :span="6" :offset="2" class="text-right">
                      <el-button @click="assignCategories()">Assign Categories</el-button>
                    </el-col>
                  </el-row>
                </div>
                <div class="scroll-pane">
                  <el-checkbox-group v-model="selected_categories">
                    <el-checkbox v-for="item in filteredCategories" :label="item.id" :key="item.id" class="checkbox-list">{{item.name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-card>
            </el-tab-pane>

            <el-tab-pane v-if="template.is_private" label="Assigned Stores" name="assigned-stores">
              <el-card 
                hover="never"
                :body-style="{ padding: '0px' }">
                <div slot="header" class="clearfix">
                  <el-row>
                    <el-col :span="16">
                      <el-input
                      style="width: 35%;"
                      :clearable="true"
                      placeholder="Filter Categories"
                      prefix-icon="el-icon-search"
                      v-model="filter_stores"></el-input>
                    </el-col>
                    <el-col :span="6" :offset="2" class="text-right">
                      <el-button @click="assignStores()">Assign Stores</el-button>
                    </el-col>
                  </el-row>
                </div>
                <div class="scroll-pane">
                  <el-checkbox-group v-model="selected_stores">
                    <el-checkbox v-for="item in filteredStores" :label="item.id" :key="item.id" class="checkbox-list">{{item.name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-card>

              <el-card 
                v-if="!template.is_private"
                hover="never"
                :body-style="{ padding: '0px' }">
                <div slot="header" class="clearfix">
                  <el-row>
                    <p>In order to assign a template to a specific or multiple stores of your choice you must first set it to "private" in the "details" tab which can be seen above on the far left</p>
                  </el-row>
                </div>
              </el-card>
            </el-tab-pane>

          </el-tabs>
        </el-col>
    </el-row>

    <pre>{{$data}}</pre>

  </div>
</template>

<style scoped>

  .checkbox-list {
    display:block;
    margin: 0 0 5px 0;
    padding: 0;
  }

  ul.sync-list {
    padding:0;
    margin:0;
    list-style: none;
  }

  ul.sync-list li {
    margin:10px 0 10px 0;
  }

  .button_card {
    text-align: center;
    margin-top: 20px;
  }

</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return { 
        config: Config.config,
        page_alias: 'Edit Template',
        page_slug: 'edit-template',
        label_position: 'top',
        active_tab: 'details',

        loading: {
          image_optimisation: false
        },

        template: {
          id: '',
          name: '',
          display_name: '',
          description: '',
          size: '',
          thumbnail_url: '',
          optimised_thumbnail_url: '',
          product_id: '',
          company_id: '',
          editable_product: '',
          is_private: '',
          created_at: '',
          updated_at: '',
          updated_user_id: ''
        },

        corporations: [],

        products: [],
        selected_products: [], 
        filter_products: '',

        categories: [],
        selected_categories: [], 
        filter_categories: '',

        selected_cororation_id: '',

        stores: [],
        selected_stores: [],
        filter_stores: '',

        rules: {
          template: {
            name: [
              {required: true, message: 'Please Enter Name', trigger: 'blur'}
            ],
            display_name: [
              {required: true, message: 'Please Enter Display Name', trigger: 'blur'}
            ],
            description: [
              {required: true, message: 'Please Enter Description', trigger: 'blur'}
            ],
            editable_product: [
              { type: 'number', required: true, message: 'Please Pick A Date', trigger: 'change' }
            ],
            corporation: [
              {required: true, message: 'Please Select A Corporation', trigger: 'blur'}
            ],
          }
        },
      };
    },

    mounted: function() {
      const me = this;
      me.getTemplate();
      me.getCorporations();
      me.getProducts();
    },

    computed: {
      filteredProducts() {
        const me = this;
        return me.products.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_products.toLowerCase())>=0;});
      },

      filteredCategories() {
        const me = this;
        return me.categories.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_categories.toLowerCase())>=0;});
      },

      filteredStores() {
        const me = this;
        return me.stores.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_stores.toLowerCase())>=0;});
      },
    },

    methods: {
      handleClick: function() {
        console.log('Handle Click Function');
        const me = this;

        if(me.active_tab == 'assigned-stores') {
          me.getStores();
          me.getAssignedStores();
        } else if(me.active_tab == 'assigned-products') {
          me.getProducts();
          me.getAssignedProducts();
        } else if(me.active_tab == 'assigned-categories') {
          me.getCategories();
          me.getAssignedCategories();
        }
      },

      getTemplate: function() {
        console.log('Get Template Function');
        const me = this;
        me.$http.get(me.config.api + 'template/{id}/?backend=1', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.template = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      updateTemplate: function(formName) {
        console.log('Update Template Function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            var jwt = Utils.decodejwt();
            me.template.updated_user_id = jwt.sub;
            me.$http.put(me.config.api + 'template/{id}/?backend=1', me.template, {params: {id : me.$route.params.id}}).then(
              response => {
              console.log('Success Putting Data')  
              console.log(response.status);
              console.log(response.statusText);
              me.getTemplate();            
              me.$notify({
                title: 'Success',
                message: 'The Template Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Error Putting Data');
              console.log(response.status);
              console.log(response.statusText);
          });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      getCorporations: function() {
        console.log('Get Corporations Function');
        const me = this;
        me.$http.get(me.config.api + 'corporation', {params: {backend_call: 1}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.corporations = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
        });
      },

      getProducts: function() {
        console.log('Get Products Function');
        const me = this;
        me.$http.get(me.config.api + 'product', {params: {pagination: 10000}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.products = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
        });
      },

      getAssignedProducts: function() {
        console.log('Get Assigned Products Function');
        const me = this;
        me.$http.get(me.config.api + 'template/{id}/product', {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          var data = response.body.data;
          me.selected_products = data.map(a => a.id);
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
        });
      },

      assignTemplateToProducts() {
        const me = this;
        console.log('Assign Templates To Products Function');
        me.$http.post(me.config.api + 'template/{id}/product', me.selected_products, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Success Posting Data');  
          console.log(response.status);
          console.log(response.statusText);
          me.getAssignedProducts();
          me.filter_products = '';
          me.$notify({
            title: 'Success',
            message: 'This Products Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('Error Posting Data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      getCategories: function(goToPage) {
        console.log('Get Categories Function');
        const me = this;
        me.$http.get(me.config.api + 'templateCategory', {params: {pagination: 10000}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.categories = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
        });
      },

      getAssignedCategories: function() {
        console.log('Get Assigned Categories Function');
        const me = this;
        me.$http.get(me.config.api + 'template/{id}/templateCategory', {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          var data = response.body.data;
          me.selected_categories = data.map(a => a.id);
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
        });
      },

      assignCategories() {
        const me = this;
        console.log('Assign Categories Function');
        me.$http.post(me.config.api + 'template/{id}/templateCategory', me.selected_categories, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('success saving data');  
          console.log(response.status);
          console.log(response.statusText);
          me.getAssignedCategories();
          me.filter_categories = '';
          me.$notify({
            title: 'Success',
            message: 'This Categories Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('error saving data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      getStores: function() {
        const me = this;
        console.log('Get Stores Function');

        var obj = me.corporations.find(function (obj) { return obj.id === me.template.company_id; });

        me.$http.get(obj.backend_portal_url  + '/api/v1/storeinfo/').then(
          response => {
            console.log('Success Getting Data')  
            console.log(response.status);
            console.log(response.statusText);
            me.stores = response.body.data;
          }, response => {
            console.log('Error Getting Data');
            console.log(response.status);
            console.log(response.statusText);
          }
        );
      },

      getAssignedStores: function() {
        console.log('Get Assigned Stores Function');
        const me = this;
        me.$http.get(me.config.api + 'template/{id}/store', {params: {id: me.$route.params.id, corporation_id: me.template.company_id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          var data = response.body.data;
          me.selected_stores = data.map(a => a.store_id);
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
        });
      },

      assignStores: function() {
        const me = this;
        console.log('Assign Stores Function');
        me.$http.post(me.config.api + 'template/{id}/store', me.selected_stores, {params: {id: me.$route.params.id, corporation_id: me.template.company_id}}).then(
          response => {
          console.log('Success Posting Data');  
          console.log(response.status);
          console.log(response.statusText);
          me.getAssignedStores();
          me.filter_stores = '';
          me.$notify({
            title: 'Success',
            message: 'This Stores Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('Error Posting Data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      optimiseImage: function() {
        console.log('Optimise Image Function');
        const me = this;
        me.loading.image_optimisation = true;
        me.$http.get(me.config.api + 'generate-thumbnail/{id}', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.loading.image_optimisation = false;
          me.getTemplate();
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.loading.image_optimisation = false;
        });
      }
    } /* END METHODS */
  }
</script>


// WEBPACK FOOTER //
// src/pages/templates/TemplateEdit.vue